import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import {
  IStudentGradeUnitDayListItemDTO,
  StudentGradeUnitDayListItemDTO,
} from '@app/infrastructure/models/grade-unit/student-grade-unit-day';
import { StatusEnum } from '@app/infrastructure/models/status';
import { StudentAssignmentStatus } from '@app/infrastructure/models/student-assignment';

@Component({
  selector: 'app-student-grade-unit-day-presentation',
  templateUrl: './student-grade-unit-day-presentation.component.html',
  styleUrls: ['./student-grade-unit-day-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudentGradeUnitDayPresentationComponent implements OnInit {
  @Input() gradeUnitDay: IStudentGradeUnitDayListItemDTO =
    new StudentGradeUnitDayListItemDTO();
  @Input() studentAssignment;
  @Input() altText: string = '';
  @Input() dayText: string = 'test';
  @Output() emitNavigate: EventEmitter<void> = new EventEmitter<void>();
  @Output() emitStartAssignment: EventEmitter<number> =
    new EventEmitter<number>();

  isAssigned: boolean = true;

  get isOverdue(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    console.log(today > new Date(this.gradeUnitDay.dueDate));
    return (
      (today > new Date(this.gradeUnitDay.dueDate) &&
        !this.studentAssignment) ||
      (today > new Date(this.gradeUnitDay.dueDate) &&
        this.studentAssignment.completedAt === null)
    );
  }

  // TODO: We need a score system
  public studentScore: number = 7;
  public unitDayTotalScore: number = 10;
  dayTitle: string = '';

  ngOnInit(): void {
    this.dayTitle = `Day ${this.gradeUnitDay.dayNumber}`;
  }

  getDateCompleted(): string {
    return this.studentAssignment.completedAt;
  }

  getDateDue(): Date {
    return this.gradeUnitDay?.dueDate;
  }

  getPageTitle(): string {
    const { dayNumber, dayEndPage, dayStartPage, isQuiz } = this.gradeUnitDay;
    if (dayNumber >= 0) {
      if (isQuiz) {
        return 'Assessment';
      } else if (dayStartPage && dayEndPage) {
        if (isNaN(Number(dayStartPage)) && isNaN(Number(dayEndPage)))
          return `${dayStartPage}  ${dayEndPage}`;
        return `Pages: ${this.gradeUnitDay.dayStartPage}-${this.gradeUnitDay.dayEndPage}`;
      } else if (dayStartPage) {
        if (isNaN(Number(dayStartPage))) return dayStartPage;
        return `Page: ${this.gradeUnitDay.dayStartPage}`;
      } else {
        return ``;
      }
    }
  }

  navigate(): void {
    this.emitNavigate.emit();
  }

  startAssignment(classroomAssignmentId): void {
    this.emitStartAssignment.emit(classroomAssignmentId);
  }

  getStatusName(): string {
    switch (this.dayText) {
      case StatusEnum.ASSIGNED:
        return 'in-progress';
      case StudentAssignmentStatus.STARTED:
        return 'started';
      case StudentAssignmentStatus.COMPLETED:
        return 'completed';
      case StudentAssignmentStatus.WRAP_UP:
        return 'wrapup';
      default:
        return 'unassigned';
    }
  }

  getColorSchemeStyle(): string {
    const status = this.getStatusName();
    return `--foreground: var(--${status}-foreground);--background: var(--${status}-background);--progress: var(--${status}-progress)`;
  }

  getColorSchemeButtonStyle(): string {
    const status = this.getStatusName();
    return `var(--${status}-background);`;
  }
}
